import axios from 'axios'
import router from '@/router'
import { initials } from '@/helpers'
import * as Types from '@/store/types'

export default
{
	state:
	{
		authenticated:                false,
		email:                        null,
		first_name:                   null,
		last_name:                    null,
		is_edi:                       null,
		is_billing:                   null,
		is_primary:                   null,
		is_registered:                null,
		is_admin:					  null,
		is_tech:                      null,
		notification_method_outage:   null,
		notification_method_standard: null,
		receive_surveys:              null,
		uses_two_factor:              null,
		view_usage:                   null,
		ccdb_id:                      null,

		employee_authenticated:       false,
		employee_logged_in:           false,
		employee_first_name:          null,
		employee_last_name:           null,
		employee_email:               null,
		employee_username:            null,
		employee_token:               null,
		employee_is_admin:            null,
		employee_is_sales:            null,
		employee_sales_group:         null,
		employee_rep_type:            null,
	},

	getters:
	{
		fullName: state => state && [ state.first_name, state.last_name ].filter(Boolean).join(' '),

		userInitials: (state, getters) => state && initials(getters.fullName),

		employeeAuthenticated: (state) => state && state.employee_authenticated,

		employeeUsername: (state) => state && state.employee_username,

		employeeFullName: (state) => state && [ state.employee_first_name, state.employee_last_name ].filter(Boolean).join(' '),

		employeeInitials: (state, getters) => state && initials(getters.employeeFullName),

		employeeIsSales: (state) => state && state.employee_is_sales,
	},

	mutations:
	{
		[Types.SET_AUTH_USER](state, payload)
		{
			state.authenticated                = true
			state.email                        = payload.user.email
			state.first_name                   = payload.user.first_name
			state.last_name                    = payload.user.last_name
			state.is_edi                       = payload.user.is_edi
			state.is_billing                   = payload.user.is_billing
			state.is_primary                   = payload.user.is_primary
			state.is_admin					   = payload.user.is_admin
			state.is_registered                = payload.user.is_registered
			state.is_tech                      = payload.user.is_tech
			state.notification_method_outage   = ( payload.user.notification_method_outage ) ? payload.user.notification_method_outage : payload.user.outage_notification
			state.notification_method_standard = ( payload.user.notification_method_standard ) ? payload.user.notification_method_standard: payload.user.standard_notification
			state.receive_surveys              = payload.user.receive_surveys
			state.uses_two_factor              = payload.user.uses_two_factor
			state.view_usage                   = ( payload.user.view_usage ) ? payload.user.view_usage : payload.user.usage_stats
			state.ccdb_id                      = ( payload.user.ccdb_id ) ? payload.user.ccdb_id : payload.user.id
		},

		[Types.UNSET_AUTH_USER](state)
		{
			state.authenticated                = false
			state.email                        = null
			state.first_name                   = null
			state.last_name                    = null
			state.is_edi                       = null
			state.is_billing                   = null
			state.is_primary                   = null
			state.is_registered                = null
			state.is_admin					   = null
			state.is_tech                      = null
			state.notification_method_outage   = null
			state.notification_method_standard = null
			state.receive_surveys              = null
			state.uses_two_factor              = null
			state.view_usage                   = null
			state.ccdb_id                      = null
		},

		[Types.SET_AUTH_EMPLOYEE](state, payload)
		{
			state.employee_authenticated = true
			state.employee_logged_in     = true
			state.employee_is_admin      = payload.user.is_admin
			state.employee_first_name    = payload.user.first_name
			state.employee_last_name     = payload.user.last_name
			state.employee_email         = payload.user.email
			state.employee_username	     = payload.user.username
			state.employee_token         = payload.user.token
			state.employee_is_sales      = payload.user.is_sales
			state.employee_sales_group   = payload.user.sales_group
			state.employee_rep_type      = payload.user.rep_type
		},

		[Types.UNSET_AUTH_EMPLOYEE](state)
		{
			state.employee_authenticated = false
			state.employee_logged_in     = false
			state.employee_is_admin      = false
			state.employee_first_name    = null
			state.employee_last_name     = null
			state.employee_email         = null
			state.employee_username      = null
		},
	},

	actions:
	{
		[Types.SET_AUTH_USER]({ commit, dispatch }, payload)
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/auth/me')
						.then
						(
							response =>
							{
								commit({ type: Types.SET_AUTH_USER, user: response.data.data })
								resolve(response)
							}
						)
						.catch
						(
							async error =>
							{
								await dispatch(Types.LOGOUT)

								reject(error)

								router.push({ name: 'auth.login' })
							}
						)
				}
			)
		},

		[Types.UNSET_AUTH_USER]({ commit, dispatch })
		{
			commit({ type: Types.UNSET_AUTH_USER })

			dispatch(Types.STOP_TOKEN_TIMER)
		},

		[Types.UNSET_AUTH_EMPLOYEE]({ commit })
		{
			commit({ type: Types.UNSET_AUTH_EMPLOYEE })
		},

		[Types.SET_AUTH_EMPLOYEE]({ commit, dispatch })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/auth/employee')
						.then
						(
							response =>
							{
								commit({ type: Types.SET_AUTH_EMPLOYEE, user: response.data.data })
								resolve(response)
							}
						)
						.catch
						(
							async error =>
							{
								await dispatch(Types.LOGOUT, { employeeLogout: true, user: this.user })

								reject(error)
							}
						)
				}
			)
		},
	},
}